import { authAxios } from '@/lib/axios';

interface PixVerificationUploadUrlResponse {
  upload_url: string;
  document_key: string;
}

export async function uploadPixVerificationDocument(file: File): Promise<string> {
  const response = await authAxios.post<PixVerificationUploadUrlResponse>(
    '/api/pix-verifications/document-upload-url',
    { contentType: file.type },
  );
  const { upload_url: uploadUrl, document_key: documentKey } = response.data;

  if (!uploadUrl || !documentKey) {
    throw new Error('pix_verification_document_upload_invalid_response');
  }

  const uploadResponse = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });

  if (!uploadResponse.ok) {
    throw new Error('pix_verification_document_upload_failed');
  }

  return documentKey;
}
